export function dragAndDrop() {
	// noop intentionally blank. Plugin is loaded via WRM
}

export function dragAndDropWRM() {
	return [
		'wr!com.atlassian.confluence.plugins.drag-and-drop:drag-and-drop-for-editor-conf-frontend',
	];
}
